export default __webpack_public_path__ + "static/media/teeth - active.ae5218f0.svg";